import { addYears } from 'date-fns';
import { filter, path, propEq, sortBy, values } from 'ramda';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import type { IPurchasedGift } from './purchasedGifts.types';

const getPurchasedGifts = (state: RootState) => state.purchasedGifts.list as Record<string, IPurchasedGift>;

export const sortPurchasedGiftsByCreatedDate = createSelector(getPurchasedGifts, (list) => sortBy(({ start }) => start, values(list)));
export const getGiftByCode = createSelector(
    getPurchasedGifts,
    (_, code: string) => code,
    (list, code) => list[code]
);
export const getNonActivatedGifts = createSelector(sortPurchasedGiftsByCreatedDate, (gifts) => filter(propEq('isGifted', false), gifts));
export const getNonActivatedNonExpiredGifts = createSelector(sortPurchasedGiftsByCreatedDate, (gifts) =>
    gifts.filter((gift) => {
        const expires = gift.expires || addYears(gift.created, 2).valueOf();
        return !path(['isGifted'], gift) && expires > Date.now();
    })
);

export const getLastPurchasedGiftById = createSelector(
    (_, giftId: string) => giftId,
    sortPurchasedGiftsByCreatedDate,
    (giftId, list) => list.find((gift) => gift.id === giftId)
);
